export const ProductStyleAnalyticsMixins = {
  data() {
    return {
      analyticsDataSent: false,
    };
  },
  updated() {
    if (window?.dataLayer && !this.analyticsDataSent && this.selectedProduct?.id) {
      this.viewItemEvent();
      this.analyticsDataSent = true;
    }
  },
  methods: {
    viewItemEvent() {
      this.clearEcommerceObject();
      window?.dataLayer?.push({
        event: 'view_item',
        ecommerce: {
          items: [
            {
              item_id: this.selectedProduct?.id || '',
              item_name: this.selectedProduct?.name?.toUpperCase() || '',
              item_category: this.selectedProduct?.type?.toUpperCase() || '',
              price: Number(this.productStyle?.price || 0).toFixed(2),
              discount: Number(Number(this.productStyle?.price || 0) - Number(this.productStyle?.discountedPrice || 0)).toFixed(2),
              quantity: 1,
              coupon: this.order?.discount?.code || '',
              currency: `${this.order?.city?.country || 'US'}D`,
              item_list_id: this.productStyle?.id || '',
              item_list_name: this.productStyle?.code?.toUpperCase() || '',
            },
          ],
        },
      });
    },
    clearEcommerceObject() {
      window?.dataLayer?.push({
        ecommerce: null,
      });
    },
  },
};
